import { render, staticRenderFns } from "./HeaderLanguageToggler.vue?vue&type=template&id=fad9170c&"
import script from "./HeaderLanguageToggler.vue?vue&type=script&lang=js&"
export * from "./HeaderLanguageToggler.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLanguageToggler.vue?vue&type=style&index=0&id=fad9170c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports